import Vue from "vue";
import App from "./App.vue";
import store from "./store.js";
import VueRouter from "vue-router";
import ElementUI from "element-ui";
import locale from "element-ui/lib/locale/lang/en";
import "./fonts/icomoon/style.css";
import VueCookies from "vue-cookies";
import "./theme/baseTheme/index.css";
import "./theme/baseStyles/index.scss";
import fullscreen from "vue-fullscreen";
import VueSSE from "vue-sse";
import "prismjs/prism";
import "prismjs/themes/prism-tomorrow.css";
import "prismjs/components/prism-json";
import VueCytoscape from "vue-cytoscape";
import { $notifyError } from "./utils/errorNotification.js";
import { httpHelper } from "./utils/httpHelper.js";
import { copyToClipboard } from "./utils/copyToClipboard.js";

const methodsPlugin = {
	install() {
		Vue.prototype.$notifyError = $notifyError;
		Vue.prototype.httpHelper = httpHelper;
		Vue.prototype.$copyToClipboard = copyToClipboard;
	},
};

Vue.use(VueSSE);
Vue.use(methodsPlugin);
Vue.use(ElementUI, { locale });
Vue.use(VueRouter);
Vue.use(VueCookies);
Vue.use(fullscreen);
Vue.use(VueCytoscape);

Vue.config.productionTip = false;

import router from "./router.js";

new Vue({
	router,
	store,
	render: (h) => h(App),
}).$mount("#app");

export default router;
